"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationCandidate = void 0;
var RegistrationCandidate_1 = require("./RegistrationCandidate");
Object.defineProperty(exports, "RegistrationCandidate", { enumerable: true, get: function () { return RegistrationCandidate_1.RegistrationCandidate; } });
